import Modal from '../../components/Modal'
import { Select, Switch } from '../../components/ui'
import { TIME_TAG_VALUES } from './utils'
import { useI18n } from '../../i18n'
import PaidSextingFields from '../../components/PaidSextingFields'

export default function SessionEditModal({
  session,
  open,
  saving,
  editingName,
  editingDescription,
  editingTags,
  editingTimeTag,
  editingIsScript,
  editingPaidSexting,
  onNameChange,
  onDescriptionChange,
  onTagsChange,
  onTimeTagChange,
  onIsScriptChange,
  onPaidSextingChange,
  onSave,
  onClose,
}) {
  const { t } = useI18n()
  const timeTagOptions = TIME_TAG_VALUES.map((value) => ({
    value,
    label:
      value === ''
        ? t('media.session.edit.timeOfDayPlaceholder')
        : t(`media.timeOfDay.${value}`),
  }))

  if (!session) return null
  return (
    <Modal
      open={open}
      title={t('media.session.edit.title')}
      onClose={onClose}
      footer={
        <div className="modal-footer-actions">
          <button type="button" className="btn btn-primary btn-sm" onClick={onSave} disabled={saving}>
            {saving ? t('common.saving') : t('common.save')}
          </button>
          <button type="button" className="btn btn-ghost btn-sm" onClick={onClose}>
            {t('common.cancel')}
          </button>
        </div>
      }
    >
      <div className="session-edit-form">
        <div className="modal-form-field session-edit-form-row">
          <Switch
            checked={editingIsScript ?? session.is_script ?? false}
            onChange={onIsScriptChange}
            label={t('media.session.edit.isScriptLabel')}
            ariaLabel={t('media.session.edit.isScriptLabel')}
          />
        </div>
        {(editingIsScript ?? session.is_script) ? <PaidSextingFields value={editingPaidSexting} onChange={onPaidSextingChange} disabled={saving} /> : null}
        <div className="modal-form-field">
          <label className="model-edit-label form-field-label">{t('media.session.edit.nameLabel')}</label>
          <input
            type="text"
            className="model-edit-input"
            value={editingName ?? session.name ?? ''}
            onChange={(e) => onNameChange?.(e.target.value)}
            placeholder={t('media.session.edit.namePlaceholder')}
          />
        </div>
        <div className="modal-form-field">
          <label className="model-edit-label form-field-label">{t('media.session.edit.descriptionLabel')}</label>
          <textarea
            className="model-edit-input model-edit-textarea"
            rows={4}
            value={editingDescription ?? session.description ?? ''}
            onChange={(e) => onDescriptionChange?.(e.target.value)}
            placeholder={t('media.session.edit.descriptionPlaceholder')}
          />
          <p className="model-edit-hint">{t('media.session.edit.descriptionHint')}</p>
        </div>
        <div className="modal-form-field">
          <label className="model-edit-label form-field-label">{t('media.session.edit.tagsLabel')}</label>
          <input
            type="text"
            className="model-edit-input"
            value={editingTags ?? (Array.isArray(session.selection_tags) ? session.selection_tags.join(', ') : '')}
            onChange={(e) => onTagsChange?.(e.target.value)}
            placeholder={t('media.session.edit.tagsPlaceholder')}
          />
          <p className="model-edit-hint">{t('media.session.edit.tagsHint')}</p>
        </div>
        <div className="modal-form-field">
          <label className="model-edit-label form-field-label">{t('media.session.edit.timeOfDayLabel')}</label>
          <Select
            className="session-edit-time-tag-select"
            value={editingTimeTag ?? session.time_tag ?? ''}
            placeholder={t('media.session.edit.timeOfDayPlaceholder')}
            options={timeTagOptions}
            onChange={(v) => onTimeTagChange?.(v)}
            dropdownPosition="down"
          />
        </div>
      </div>
    </Modal>
  )
}
